/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'

const IconSparkBooks = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36.068"
    height="50.182"
    viewBox="0 0 36.068 50.182"
  >
    <g transform="translate(-72)">
      <path
        d="M73.568,44.693A1.568,1.568,0,0,1,72,43.125V6.469A6.476,6.476,0,0,1,78.469,0H106.5a1.568,1.568,0,0,1,1.568,1.568V37.637a1.568,1.568,0,1,1-3.136,0V3.136H78.469a3.336,3.336,0,0,0-3.332,3.332V43.125A1.568,1.568,0,0,1,73.568,44.693Z"
        fill="#b0bac1"
      />
      <path
        d="M106.5,382.114H79.057a7.057,7.057,0,1,1,0-14.114H106.5a1.568,1.568,0,1,1,0,3.136H79.057a3.92,3.92,0,0,0,0,7.841H106.5a1.568,1.568,0,1,1,0,3.136Z"
        transform="translate(0 -331.932)"
        fill="#b0bac1"
      />
      <path
        d="M157.012,427.136H129.568a1.568,1.568,0,1,1,0-3.136h27.443a1.568,1.568,0,1,1,0,3.136Z"
        transform="translate(-50.511 -382.443)"
        fill="#b0bac1"
      />
      <path
        d="M145.568,39.2A1.568,1.568,0,0,1,144,37.637V1.568a1.568,1.568,0,0,1,3.136,0V37.637A1.568,1.568,0,0,1,145.568,39.2Z"
        transform="translate(-64.943)"
        fill="#b0bac1"
      />
    </g>
  </svg>
)

export default withIconStyles(IconSparkBooks)
